var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 413.348 413.348","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }